import { render, staticRenderFns } from "./ListTipos.vue?vue&type=template&id=00496931"
import script from "./ListTipos.vue?vue&type=script&lang=js"
export * from "./ListTipos.vue?vue&type=script&lang=js"
import style0 from "./ListTipos.vue?vue&type=style&index=0&id=00496931&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports